var baseStyle = props => ({
  backgroundColor: props.selected ? 'brand.500' : undefined,
  alignItems: 'center',
  borderRadius: '20px',
  cursor: 'pointer',
  display: 'flex',
  fontSize: '14px',
  fontWeight: 700,
  height: '32px',
  justifyContent: 'center',
  lineHeight: '14px',
  width: '48px',
  outline: 'none',
  color: props.selected ? 'white' : undefined,
  _hover: {
    backgroundColor: !props.selected ? 'gray.100' : undefined
  },
  _disabled: {
    color: 'gray.400',
    cursor: 'not-allowed',
    fontWeight: 'normal',
    _hover: {
      backgroundColor: 'none'
    }
  }
});

export default {
  baseStyle
};
//# sourceMappingURL=TimeButton.js.map